import React from 'react';
import PropTypes from 'prop-types';
import CustomIcon from '../../common/CustomIcon';
import { isElectronApp } from '../../../services/crossPlatform/crossPlatformService';
import { openCookiesDetail } from '../../../electron/windowManager';

export const Chip = ({ name, id, category, removeChip, primary, removeCloseButton, linksTo, cookiesInfoUrl }) => {
  const cookieChipsOnClick = () => {
    openCookiesDetail(cookiesInfoUrl);
  };

  const chipContent = (
    <div style={{ cursor: linksTo ? 'pointer' : 'default' }} className="custom-chip" key={id + category}>
      <div className="custom-chip-text">
        <span>{name}</span>
      </div>
      {!removeCloseButton && (
        <button onClick={removeChip} type="button">
          <CustomIcon name="close-button" size={18} />
        </button>
      )}
    </div>
  );

  if (linksTo) {
    if (!isElectronApp()) {
      return (
        <a href={linksTo} target="_blank" rel="noopener noreferrer">
          {chipContent}
        </a>
      );
    } else {
      return <a onClick={cookieChipsOnClick}>{chipContent}</a>;
    }
  }

  return chipContent;
};

Chip.propTypes = {
  name: PropTypes.string.isRequired,
  category: PropTypes.string,
  removeChip: PropTypes.func,
  primary: PropTypes.string,
  removeCloseButton: PropTypes.bool,
  linksTo: PropTypes.string,
  id: PropTypes.any
};

export default Chip;
